import classNames from 'classnames';
import AIIcon from 'components/atoms/SVG/AIIcon';
import type { FC } from 'react';

type AIMessageAvatarProps = {
  role: string;
  isStreaming: boolean;
  isSmall: boolean;
  isLastAssistantMessage?: boolean;
};

const AIMessageAvatar: FC<AIMessageAvatarProps> = ({
  role,
  isStreaming,
  isSmall,
  isLastAssistantMessage,
}) => {
  if (role === 'user') return null;

  // Show spinning avatar for the last message when loading/streaming
  const shouldSpin = isLastAssistantMessage && isStreaming;

  return (
    <div
      className={classNames(
        'rounded-full bg-taxes-200 flex items-stretch justify-center flex-shrink-0',
        isSmall ? 'w-5 h-5 p-[1px]' : 'w-8 h-8 p-[1px]',
        { 'ai-border-spin': shouldSpin },
        { 'animate-[spin_2s_linear_infinite]': shouldSpin },
      )}
    >
      <div
        className={classNames(
          'flex flex-1 items-center justify-center rounded-full bg-white',
        )}
      >
        <AIIcon
          stroke="#8059C8"
          className={classNames(isSmall ? 'w-4 h-4' : 'w-7 h-7')}
        />
      </div>
    </div>
  );
};

export default AIMessageAvatar;
